import React from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import '/node_modules/react-grid-layout/css/styles.css'
import '/node_modules/react-resizable/css/styles.css'
import '/node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-phone-input-2/lib/material.css'
import "@fontsource/dm-sans/700.css"
import "@fontsource/dm-sans/400.css"
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

require('dotenv').config()

// Suppress benign ResizeObserver loop notification from ReactFlow's NodeResizer.
// This is a known non-breaking browser quirk — the observer fires faster than
// the browser can deliver callbacks in a single frame.
window.addEventListener('error', (e) => {
    if (e.message?.includes('ResizeObserver loop')) {
        e.stopImmediatePropagation();
    }
}, true); // capture phase — runs before CRA's error overlay listener

const root = document.getElementById('root');

ReactDOM.render(
    <App/>,
    root
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
